import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { BalancoFinanceiroResponse, FiltroRelatorioBalancoFinanceiro } from "../typings";
import http  from 'infra/http';

export function useRelatorioBalancoFinanceiro(query: FiltroRelatorioBalancoFinanceiro) {
  return useQuery<BalancoFinanceiroResponse, AxiosError>(
    ['/v1/relatorios/financeiro/balanco-financeiro', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/balanco-financeiro', {
        params: query
      })

      return data;
    }
  );
}
